
import { mapState } from 'vuex';
import { TENANT_UK } from '@/constants/tenant';

export default {

    data () {
        return {
            metadata: null
        };
    },

    head () {
        return {
            htmlAttrs: {
                lang: this.$t('lang')
            },
            title: this.$t('meta.title'),
            meta: this.metadata,
            script: [
                {
                    type: 'text/javascript',
                    hid: 'oidc-client',
                    src: `${this.settings.auth.authority}/tokenweb/content/oidc-client.min.js`
                }
            ]
        };
    },

    computed: {
        ...mapState('configuration', [
            'settings'
        ]),

        ...mapState('globalisation', [
            'tenant',
            'locale'
        ])
    },

    created () {
        this.$i18n.locale = this.locale;

        const description = {
            hid: 'description',
            name: 'description',
            content: this.$t('meta.description')
        };

        let social = [];

        if (this.tenant === TENANT_UK) {
            social = [
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: this.$t('meta.title')
                },
                {
                    hid: 'og:type',
                    name: 'og:type',
                    content: 'article'
                },
                {
                    hid: 'og:url',
                    name: 'og:url',
                    content: this.$t('meta.canonical')
                },
                {
                    hid: 'og:image',
                    name: 'og:image',
                    content: this.$t('meta.social.cardImage')
                },
                {
                    hid: 'og:description',
                    name: 'og:description',
                    content: this.$t('meta.description')
                },
                {
                    hid: 'og:site_name',
                    name: 'og:site_name',
                    content: this.$t('meta.social.name')
                },
                {
                    hid: 'twitter:card',
                    name: 'twitter:card',
                    content: 'summary_large_image'
                },
                {
                    hid: 'twitter:site',
                    name: 'twitter:site',
                    content: this.$t('meta.social.twitterAccount')
                },
                {
                    hid: 'twitter:title',
                    name: 'twitter:title',
                    content: this.$t('meta.title')
                },
                {
                    hid: 'twitter:description',
                    name: 'twitter:description',
                    content: this.$t('meta.social.schemaOrg.description')
                },
                {
                    hid: 'twitter:creator',
                    name: 'twitter:creator',
                    content: this.$t('meta.social.twitterAccount')
                },
                {
                    hid: 'twitter:image:src',
                    name: 'twitter:image:src',
                    content: this.$t('meta.social.cardImage')
                }
            ];
        }

        this.metadata = [
            description,
            ...social
        ];
    }
};
